export const isMobileBrowser = (): boolean => {
  if (window) {
    return window?.matchMedia('only screen and (max-width: 760px)')?.matches;
  } else return false;
};
